import { render, staticRenderFns } from "./Wizard-1.vue?vue&type=template&id=216a1851&"
import script from "./Wizard-1.vue?vue&type=script&lang=js&"
export * from "./Wizard-1.vue?vue&type=script&lang=js&"
import style0 from "./Wizard-1.vue?vue&type=style&index=0&id=216a1851&prod&lang=scss&"
import style1 from "./Wizard-1.vue?vue&type=style&index=1&id=216a1851&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports